/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { DppQrCodeTab } from '@/app/(client)/my-styles/-components/DppQrCodeTab';
import {
  type EntityKindPath,
  isEntityKindPath,
  useEntityDetail,
} from '@/app/(client)/my-styles/-hooks/useEntityDetail';

export const Route = createFileRoute(
  '/(client)/my-components/(pages)/(detail)/$kind/$id/qr-code',
)({
  component: DppQrCodeRoute,
});

function DppQrCodeRoute() {
  const { kind, id } = Route.useParams() as {
    kind: EntityKindPath;
    id: string;
  };
  const { data: entity } = useEntityDetail(kind, id);
  if (!isEntityKindPath(kind)) return null;
  return (
    <DppQrCodeTab
      qrCodeUrl={entity?.qrCodeUrl}
      entityName={entity?.name ?? ''}
    />
  );
}
